import Backdrop from "@/components/base/backdrop";
import PageLayout from "@/components/base/page-layout";
import withErrorBoundary from "@/components/hoc/with-error-boundary";
import Orders from "@/components/orders";
import useQueryOrders from "@/hooks/queries/useQueryOrders";

const OrdersPage = () => {
  const { data: orders, isFetching } = useQueryOrders();


  if (!orders) {
    return <Backdrop loading={isFetching} />;
  }

  return (
    <PageLayout title="Orders" showCalendar={true}>
      <Orders data={orders} />
    </PageLayout>
  );
};

export default withErrorBoundary({ component: "OrdersPage" })(OrdersPage);
